import moment from "moment"
import React from "react"

interface ComponentProps {
    time: Date,
    formatStr?: string,
}

const Time = ({ time, formatStr = "YYYY/MM/DD HH:mm:ss" }: ComponentProps) => {
    return (
        <div>{moment(time).format(formatStr)}</div>
    )
}

export default Time
